export default "__VITE_ASSET__28088b77__"